import React from "react";
import { Router, Route, match, Switch } from "react-router-dom";
import { createBrowserHistory, History } from "history";

import { NotificationsContainer, NotFoundPage } from "fe-shared/src/components";
import useExternalAxiosConfig from "fe-shared/src/hooks/useExternalAxiosConfig";
import { Company, User, UserInfo } from "fe-shared/src/types/domain";

import { EXTERNAL_CLIENT_ID } from "fe-shared/src/consts";

import UserContext from "contexts/userContext";
import RequestsPage from "../../routes/Requests";
import RequestDetailsPage from "../../routes/RequestDetails";

enum Feature {
  Requests = "Requests",
}

interface Props {
  history?: History;
  match?: match<{}>;
  apiBaseUrl?: string;
  feature?: Feature;
  user?: {
    token: string;
    data: User;
  };
  company?: Company;
  setUserData?: (data: UserInfo | null) => void;
  refreshTokenUrl?: string;
  refreshTokenBaseUrl?: string;
  forbiddenCallback?: () => void;
  sessionId?: string;
}

const defaultProps = {
  setUserData: (data: UserInfo | null) => data,
};

const App = (props: Props) => {
  const {
    apiBaseUrl,
    user,
    company,
    setUserData = defaultProps.setUserData,
    feature,
    refreshTokenUrl,
    refreshTokenBaseUrl,
    forbiddenCallback,
    sessionId,
  } = props;
  const matchUrl = props.match?.url || "";
  const history = props.history || createBrowserHistory();
  const isReady = useExternalAxiosConfig(
    user,
    setUserData,
    apiBaseUrl,
    refreshTokenUrl,
    company?.companyId,
    forbiddenCallback,
    sessionId,
    EXTERNAL_CLIENT_ID,
    refreshTokenBaseUrl
  );

  if (!isReady) {
    return null;
  }

  return (
    <UserContext.Provider value={user?.data}>
      <Router history={history}>
        <Switch>
          {feature === Feature.Requests && (
            <Route path={matchUrl} exact>
              <RequestsPage company={company!} />
            </Route>
          )}
          {feature === Feature.Requests && (
            <Route path={`${matchUrl}/:requestNumber`} exact>
              <RequestDetailsPage company={company!} returnUrl={matchUrl} />
            </Route>
          )}
          <Route path="*">
            <NotFoundPage />
          </Route>
        </Switch>
        <NotificationsContainer />
      </Router>
    </UserContext.Provider>
  );
};

export default App;
